'use strict';
// jQuery extensions

export default function () {
	// params
	// toggleClass - required
	// triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
	// eventName - optional. defaults to 'click'
	$.fn.toggledList = function (options) {
		if (!options.toggleClass) {
			return this;
		}
		var list = this;
		return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
			e.preventDefault();
			var classTarget = options.triggerSelector ? $(this).parent() : $(this);
			classTarget.toggleClass(options.toggleClass);
			// execute callback if exists
			if (options.callback) {
				options.callback();
			}
		});
	};
	var getHeightProperty = function () {
		var browser_id = 0;
		var property = [
			// To avoid content overflow in synchronised boxes on font scaling, we
			// use 'min-height' property for modern browsers ...
			['min-height', '0px'],
			// and 'height' property for Internet Explorer.
			['height', '1%']
		];

		var bMatch = /(msie) ([\w.]+)/.exec(navigator.userAgent.toLowerCase()) || [],
			browser = bMatch[1] || "",
			browserVersion = bMatch[2] || "0";

		// check for IE6 ...
		if (browser === 'msie' && browserVersion < 7) {
			browser_id = 1;
		}

		return {
			'name': property[browser_id][0],
			'autoheightVal': property[browser_id][1]
		};
	};

	$.getSyncedHeight = function (selector) {
		var max = 0;
		var heightProperty = getHeightProperty();
		// get maximum element height ...
		$(selector).each(function () {
			// fallback to auto height before height check ...
			$(this).css(heightProperty.name, heightProperty.autoheightVal);
			var val = parseInt($(this).css('height'), 10);

			if (val > max) {
				max = val;
			}
		});
		return max;
	};

	$.fn.syncHeight = function (config) {
		var defaults = {
			updateOnResize: false, // re-sync element heights after a browser resize event (useful in flexible layouts)
			height: false,
			parentElement: ''
		};

		var options = $.extend(defaults, config);
		var e = this;
		var max = 0;
		var heightPropertyName = getHeightProperty().name;

		if (typeof (options.height) === "number") {
			max = options.height;
		} else {
			max = $.getSyncedHeight(this);
		}

		// set synchronized element height ...
		$(this).each(function () {
			// optional sync refresh on resize event ...
			$(this).css(heightPropertyName, max + 'px');
			if (options.parentElement !== '') {
				$(this).closest(options.parentElement).css('height', max + 'px');
			}
		});

		// optional sync refresh on resize event ...
		if (options.updateOnResize === true) {
			$(window).bind('resize.syncHeight', function () {
				if (options.parentElement !== '') {
					$(e).syncHeight({
						parentElement: options.parentElement
					});
				} else {
					$(e).syncHeight();
				}
			});
		}
		return this;
	};

	$.fn.unSyncHeight = function () {
		// unbind optional resize event ...
		$(window).unbind('resize.syncHeight');

		var heightPropertyName = getHeightProperty().name;
		$(this).each(function () {
			if (options.parentElement !== '') {
				$(this).closest(options.parentElement).css(height, '');
			}
			$(this).css(heightPropertyName, '');
		});
	};
};